<template>
  <v-dialog :value="true" persistent max-width="760" scrollable>
    <section class="ai-mails mail-notes-dialog" aria-labelledby="tac-notes-title" @keydown.esc.stop.prevent="close">
      <header class="mail-row"><div><h2 id="tac-notes-title">TAC-Notizen</h2><p class="muted">{{ memberName }} · direkt im Mitgliedsprofil</p></div><button type="button" :disabled="saving" @click="close" aria-label="Notizen schliessen"><v-icon aria-hidden="true">mdi-close</v-icon></button></header>
      <p v-if="error" class="mail-notice warning" role="alert">{{ error }}</p>
      <p v-if="notice" class="mail-notice" role="status">{{ notice }}</p>
      <p v-if="loading" role="status">Notizen werden aus TAC geladen …</p>
      <template v-if="notes.length">
        <label for="tac-note-type">Bereich</label><select id="tac-note-type" v-model="type" :disabled="saving || loading"><option v-for="note in notes" :key="note.type" :value="note.type">{{ note.type }}{{ drafts[note.type] !== note.text ? ' · ungespeichert' : '' }}</option></select>
        <label class="mail-notes-label" for="tac-note-text">{{ type }}</label><textarea id="tac-note-text" v-model="drafts[type]" rows="10" maxlength="50000" :disabled="saving || loading" @input="notice = ''"></textarea>
        <p class="muted">{{ current.updatedAt ? 'Im TAC aktualisiert: ' + formatDate(current.updatedAt, true) : 'Kein Änderungsdatum von TAC verfügbar' }}</p>
        <details v-if="drafts[type] !== current.text" class="mail-section"><summary>Aktueller TAC-Text zum Vergleichen</summary><pre class="mail-note-reference">{{ current.text || '(Leer)' }}</pre></details>
      </template>
      <div class="mail-actions"><button :disabled="loading || saving" @click="load">{{ needsReload ? 'Neu laden und vergleichen' : 'Aus TAC aktualisieren' }}</button><button class="primary" :disabled="!current || loading || saving || needsReload || drafts[type] === current.text" @click="save">{{ saving ? 'Wird gespeichert …' : 'Im TAC speichern' }}</button></div>
      <small v-if="loadedAt">Aus TAC geladen: {{ formatDate(loadedAt, true) }}. Speichern ersetzt den Text des gewählten Bereichs.</small>
    </section>
  </v-dialog>
</template>
<script>
import api, { errorText, formatDate } from "@/api/aiMails"
export default {
  props: { caseId: String, memberName: String },
  data: () => ({ notes: [], drafts: {}, type: "Büro", revision: null, loadedAt: null, loading: false, saving: false, needsReload: false, error: "", notice: "", stopped: false }),
  computed: {
    current() { return this.notes.find(note => note.type === this.type) },
    dirty() { return this.notes.some(note => this.drafts[note.type] !== note.text) },
  },
  watch: { dirty(value) { this.$emit("dirty", value) } },
  mounted() { this.load() },
  beforeDestroy() { this.stopped = true },
  methods: {
    formatDate,
    close() { if (this.saving || (this.dirty && !window.confirm("Ungespeicherte TAC-Notizen verwerfen?"))) return; this.$emit("dirty", false); this.$emit("close") },
    async load() {
      if (this.loading || this.saving) return
      this.loading = true; this.error = ""; this.notice = ""
      try {
        const result = await api.notes(this.caseId)
        if (this.stopped) return
        if (this.revision !== null && this.revision !== result.revision && this.dirty) {
          this.needsReload = true
          this.error = "Die Mitgliedszuordnung oder TAC-Daten wurden geändert. Kopiere deinen Entwurf und öffne die Notizen erneut, um die Zuordnung zu prüfen."
          return
        }
        const drafts = {}; let preserved = false
        for (const note of result.notes) {
          const old = this.notes.find(value => value.type === note.type)
          const edited = old && this.drafts[note.type] !== old.text
          drafts[note.type] = edited ? this.drafts[note.type] : note.text
          if (edited && drafts[note.type] !== note.text) preserved = true
        }
        this.drafts = drafts; this.notes = result.notes; this.revision = result.revision; this.loadedAt = result.loadedAt; this.needsReload = false
        if (preserved) this.notice = "Aktueller TAC-Stand geladen. Deine ungespeicherten Texte bleiben erhalten. Bitte vor dem Speichern vergleichen."
      } catch (error) { if (!this.stopped) { this.error = errorText(error); this.needsReload = true } }
      finally { if (!this.stopped) this.loading = false }
    },
    async save() {
      if (!this.current || this.loading || this.saving || this.needsReload || this.drafts[this.type] === this.current.text) return
      const type = this.type
      this.saving = true; this.error = ""; this.notice = ""; this.$emit("saving", true)
      try {
        const result = await api.saveNote(this.caseId, { type, text: this.drafts[type], version: this.current.version, revision: this.revision })
        if (this.stopped) return
        this.notes = this.notes.map(note => note.type === type ? result.note : note)
        this.$set(this.drafts, type, result.note.text); this.loadedAt = result.loadedAt
        this.notice = `${type} wurde im TAC gespeichert.`
      } catch (error) { if (!this.stopped) { this.error = errorText(error); this.needsReload = true } }
      finally { if (!this.stopped) { this.saving = false; this.$emit("saving", false) } }
    },
  },
}
</script>
